import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ChatSyncError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ChatSyncError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ChatSyncError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatSyncError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
